import styled from "styled-components";

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  height: 50px;
`;

export const FiltersLeftContent = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  & > div:first-child {
    width: auto;
  }
`;

export const FiltersRightContent = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
`;

export const DropdownWrapper = styled.div`
  min-width: 150px;
`;

export const SelectToolbarWrapper = styled.div`
  margin-bottom: 16px;

  ${props => props.firstThreeIcons && `
    & > div > div > div > div:nth-child(2) > button:nth-child(1),
    & > div > div > div > div:nth-child(2) > button:nth-child(2),
    & > div > div > div > div:nth-child(2) > button:nth-child(3) 
    {
      opacity: 0.6;
      pointer-events: none;
      cursor: not-allowed;
    }
  `}

  /* Always disable the third button (group_remove) visually */
  & > div > div > div > div:nth-child(2) > button:nth-child(3) {
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
  }
`;

export const ClearFiltersButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;

